import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import axios from 'axios';

import PropTypes from 'prop-types';

import { Loader, Dimmer, Grid, Modal, Checkbox, Button, Divider } from 'semantic-ui-react';
import ProcessTable from './processes';
import JobTable from './JobTable';
import { WelcomeText, LoginInfo, MapServices } from './InfoTexts';

import PreviewMap from './PreviewMap';

import config from '../../config/';

import { getJobs } from "../../reducers/jobs";
import { getFiles } from "../../reducers/files";
import { getNews } from "../../reducers/news";
import { closePreview, setApprovePreview } from "../../reducers/publish";


axios.defaults.withCredentials = true;

class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lastUpdate: undefined,
    }
  }

  componentDidMount() {
    this.createFileListing();
    this.props.getJobs();
    this.props.getNews();
    // Set up longer interval to fetch job status regulary.
    this.longInterval = setInterval(() => {
      this.props.getJobs();
      this.props.getFiles();
    }, 15000);
  }

  componentWillUnmount() {
    clearInterval(this.fileInterval);
    clearInterval(this.longInterval);
  }

  createFileListing() {
    // Create a job to read all files in the ftp.
    axios.get(config.api.updateProcess);
    this.setState({ lastUpdate: new Date().getTime() });

    // Set up interval to fetch ftp file listing.
    this.fileInterval = setInterval(() => {
      this.props.getFiles();
    }, 2500);
  }

  handlePreviewClose = () => {
      this.props.closePreview();
  }

  setApprovePreview = () => {
      this.props.setApprovePreview(!this.props.publish.previewDetails.isApproved);
  }

  publishLayer = () => {
    axios.get(`${config.api.publishLayer}${this.props.publish.previewDetails.layer}/`);
    setTimeout(() => {
      this.props.getJobs();
      this.props.getFiles();
    }, 2000);
    this.props.closePreview();
  }

  render() {
    const user = this.props.user.user;
    const jobs = this.props.jobs.jobs;
    const files = this.props.files;
    const fileList = files && new Date(files.timestamp).getTime() > this.state.lastUpdate ? files.files : undefined;

    // console.log(ftpFileList);
    // console.log(webFileList);

    // If the suitable files are found, it is not needed to ask jobs any more
    if (fileList) {
      clearInterval(this.fileInterval);
    }

    // Sort jobs and filter those that are over one year old.
    const date = new Date();
    date.setFullYear(date.getFullYear()-1);
    const filteredJobs = jobs.filter(job => new Date(job.updated) > date)
                             .sort((a, b) => (b.id - a.id))
                             .slice(0, 20);

    if (!user) {
      return (
        <div>
          <Dimmer active inverted>
            <Loader inverted>Ladataan...</Loader>
          </Dimmer>
        </div>
      );
    }

    return (
      <div>
        <Grid centered columns={1}>
          <Grid.Row>
            <Grid.Column>
              <LoginInfo user={user}/>
              <WelcomeText user={user}/>
              <MapServices mapservices={user.mapservices} workspace={user.organization}/>
              <ProcessTable
                files={fileList}
                refreshFiles={() => this.createFileListing()}
              />
              <JobTable jobs={filteredJobs}/>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Modal open={this.props.publish.isPreviewing} onClose={this.handlePreviewClose} closeIcon>
          <Modal.Header>{`Esikatselu - ${this.props.publish.previewDetails.displayName}`}</Modal.Header>
          <Modal.Content>
            <PreviewMap 
              workspace={this.props.publish.previewDetails.workspace} 
              layer={this.props.publish.previewDetails.layer} 
              isPreview={true}
              apikey={this.props.publish.previewDetails.apikey}
            />
            <Divider />
            <Modal.Description>
              <Checkbox label='Olen tarkastanut ja hyväksynyt tämän tason' onChange={this.setApprovePreview} checked={this.props.publish.previewDetails.isApproved} />
              <Divider />
              <Button
                onClick={this.publishLayer}
                content="Julkaise taso"
                disabled={!this.props.publish.previewDetails.isApproved}
              />
            </Modal.Description>
          </Modal.Content>
        </Modal>
      </div>
    );
  }
}

Main.propTypes = {
  user: PropTypes.object.isRequired,
  jobs: PropTypes.object.isRequired,
  files: PropTypes.object.isRequired,
  publish: PropTypes.object.isRequired,
}

const mapStateToProps = state => {
  return {
    user: state.user,
    jobs: state.jobs,
    files: state.files,
    publish: state.publish
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  getJobs: () => getJobs(),
  getFiles: () => getFiles(),
  getNews: () => getNews(),
  closePreview: () => closePreview(),
  setApprovePreview: (b) => setApprovePreview(b),
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Main);



// WEBPACK FOOTER //
// ./src/containers/main/index.js